import axios from 'axios';
import {getEnvironment} from "./environmantDetection";

function isMobile() {
    return window.innerWidth <= 1024 || window.innerHeight <= 600;
}

// Fuctions returns whether given shared project is already liked or not
function isProjectLikedByMe(users, currentUser) {
    // console.log('currentUser', currentUser);
    if (!users || !(users instanceof Array) || !currentUser) {
        return false;
    }
    for (var i = 0; i < users.length; i++) {
        if (users[i].userId === currentUser) {
            return true;
        }
    }
    return false;
}


// function returns user information.
function getUserDetails() {
    let env = getEnvironment();
    if (env !== "prod.") {
        env = "." + env;
    } else {
        env = ".";
    }
    let baseUrl = "https://www" + env + "shutterfly.com/userstate/query.sfly";
    return window.evalUseNewAuth()
        .then(useNewAuth => {
            if (useNewAuth) {
                return window.$sflyAuth.getIdToken()
                    .then(idToken => {
                        return window.$sflyAuth.getCurrentUser();
                    })
            } else {
                // Use the old way of logging in
                return axios.get(baseUrl);
            }
        })
}

function saveToLocalhost(key, value = true) {
    localStorage.setItem(key, value);
}

function getLocalStorageByKey(key) {
    return localStorage.getItem(key);
}

function removeLocalStorage(key) {
    localStorage.removeItem(key);
}

function preservePendingCalls(body) {
    const {shareProject, likeProject, totalComments, commentId} = body;
    if (shareProject) {
        saveToLocalhost("shareProject");
    }
    if (likeProject) {
        saveToLocalhost('likeProject');
    }
    if (commentId) {
        saveToLocalhost('commentId', commentId)
    }
    if (totalComments) {
        saveToLocalhost('totalComments', totalComments)
    }
}


function clearPreservedData() {
    localStorage.removeItem('likeProject');
    localStorage.removeItem('shareProject');
    localStorage.removeItem('commentId');
    localStorage.removeItem('totalComments');
}


const helpers = {
    isMobile,
    isProjectLikedByMe,
    getUserDetails,
    saveToLocalhost,
    getLocalStorageByKey,
    removeLocalStorage,
    preservePendingCalls,
    clearPreservedData
};

export default helpers;